var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visibility-show_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".visibility-show_svg__dt{fill:url(#visibility-show_svg__ds)}.visibility-show_svg__du{fill:#272727}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visibility-show_svg__ds",
    x1: 142.95,
    y1: 214.29,
    x2: 286.36,
    y2: 214.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "visibility-show_svg__du",
    d: "m311.86,143.81c-29.77-15.58-63.38-23.82-97.19-23.81h0c-33.82,0-67.44,8.24-97.21,23.81-28.81,15.07-54.11,37.01-73.18,63.43-1.77,2.46-2.51,5.41-2.22,8.28l-1.3.93,7.02,9.74.07-.05c18.59,24.27,42.54,44.46,69.59,58.62,29.78,15.58,63.4,23.82,97.23,23.81h0c33.82,0,67.44-8.24,97.21-23.81,28.8-15.07,54.1-37.01,73.15-63.43,3.04-4.21,3.04-9.87,0-14.08-19.07-26.42-44.37-48.35-73.17-63.43Zm-97.19.26c30.37,0,59.31,7.09,86.03,21.07,22.86,11.96,43.34,28.89,59.47,49.14-16.12,20.24-36.59,37.18-59.45,49.14-26.72,13.98-55.67,21.07-86.05,21.07-30.38,0-59.34-7.09-86.07-21.07-22.87-11.96-43.34-28.9-59.46-49.14,16.14-20.25,36.61-37.18,59.47-49.14,26.72-13.98,55.68-21.07,86.06-21.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "visibility-show_svg__dt",
    d: "m286.36,214.29c0-19.16-7.46-37.17-21-50.7-13.53-13.54-31.54-21-50.71-21s-37.16,7.46-50.69,21c-13.55,13.53-21.01,31.54-21,50.7,0,19.16,7.46,37.17,21,50.7,13.53,13.54,31.54,21,50.7,21h.01c19.15,0,37.16-7.46,50.69-21,13.55-13.54,21.01-31.54,21-50.7Zm-71.7,47.63c-12.72,0-24.68-4.96-33.68-13.95-8.99-9-13.95-20.96-13.95-33.68,0-12.72,4.96-24.68,13.95-33.68,9-8.99,20.97-13.95,33.68-13.95,12.71,0,24.68,4.96,33.68,13.95,8.99,9,13.95,20.96,13.95,33.68,0,12.72-4.96,24.68-13.95,33.68-9,9-20.97,13.95-33.68,13.95Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityShow);
export default __webpack_public_path__ + "static/media/visibility-show.4ed749a241adf6a92fe973378400b03f.svg";
export { ForwardRef as ReactComponent };